import { AxiosResponse } from 'axios';
import { SearchPersonTableVM } from 'civil-status/view-models/accordion-generality-form';
import { DateTime } from 'luxon';
import { ConsultazioneANSCResponse } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';

export const transformerResearchIdAnscList = (
  response: AxiosResponse<HttpResponse<ConsultazioneANSCResponse>>
): Array<SearchPersonTableVM> => {
  const responseData = response.data.payload.soggetti || [];
  return responseData.map((itemSubject) => ({
    name: itemSubject.nome || '',
    surname: itemSubject.cognome || '',
    fiscalCode: itemSubject.codiceFiscale || '',
    gender: itemSubject.sesso || '',
    dateBorn: itemSubject.dataNascita
      ? DateTime.fromISO(itemSubject.dataNascita).toFormat('dd/MM/yyyy')
      : undefined,
    placeBorn: itemSubject.nomeComuneNascita
      ? `${itemSubject.nomeComuneNascita || ''} ${
          itemSubject.siglaProvinciaNascita ? `(${itemSubject.siglaProvinciaNascita})` : ''
        }`
      : itemSubject.nomeStatoNascita || '',
    residence: itemSubject.nomeComuneResidenza
      ? `${itemSubject.nomeComuneResidenza || ''} ${
          itemSubject.siglaProvinciaResidenza ? `(${itemSubject.siglaProvinciaResidenza})` : ''
        }`
      : itemSubject.nomeStatoResidenza || '',
    idAnsc: itemSubject.id || '',
  }));
};
